import * as apis from '@/apis/numberPort';
import * as actions from '@/actions/numberPort';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
  PARTICULARS_MOBILE_OPERATOR_REQUEST,
  CHECK_NUMBER_PORT_REQUEST
} from '@/actions/numberPort/actionTypes';
import { CheckNumberPortRequest } from '@/actions/numberPort/models/types';

function* getMobileOperatorValues() {
  try {
    const result = yield call(apis.getMobileOperatorValues);
    yield put(actions.getMobileOperator.success(result.data));
  } catch (error) {
    yield put(actions.getMobileOperator.failure(error));
  }
}

function* checkNumberPort({ reqData, callback }: CheckNumberPortRequest) {
  try {
    const result = yield call(apis.checkNumberPort, reqData);
    yield put(actions.checkNumberPort.success({ eligibilityData: result.data, subscriberDetails: reqData }));
    callback()
  } catch (error) {
    yield put(actions.checkNumberPort.failure(error));
  }
}

export default function* numberPortSagas() {
  yield takeLatest(PARTICULARS_MOBILE_OPERATOR_REQUEST, getMobileOperatorValues);
  yield takeLatest(CHECK_NUMBER_PORT_REQUEST, checkNumberPort);
}
